import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { KeyWord } from 'src/app/shared/classes/constants';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
  selector: 'app-bulk-audit',
  templateUrl: './bulk-audit.component.html',
  styleUrls: ['./bulk-audit.component.scss']
})
export class BulkAuditComponent implements OnInit {

  @Input() public country?: any;
  @Input() public language?: any;
  @Input() public queryData?: any;

  bulkAuditForm!: FormGroup;
  selectedFlag = "";
  theme: boolean = true;
  nlp: boolean = true;
  dropDownCountry: any = KeyWord.editorAuditCountry;
  mainDropDownCountry: any = KeyWord.editorAuditCountry;
  languageDropdown = KeyWord.editorAuditLanguages;
  mainLanguageDropdown = KeyWord.editorAuditLanguages;

  defaultFlag = `https://flagpedia.net/data/flags/normal/us.png`;
  countryValue: string = "United States:us";
  languageType: string = "en";
  index: number[] = [0];
  Searchedlanguages: any[] = [];
  SearchedCountries: any[] = [];
  languageIndex!: number;
  countryIndex!: number;
  selected = 'United States';
  crawlType: string = "Desktop";
  keyWordName: string = "";
  url: string = "";
  mainFormCountryIndex: number = 1;
  isSelecting: boolean = false;
  count = 0;
  key = "";
  languageKey = "";
  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, private toasterService: ToastrService, private themingService: ThemingService) {
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    })
    this.bulkAuditForm = this.fb.group({
      bulkContent: [this.fb.array([])],
    });
    // this.addContent();
  }
  get selectMenu() {
    return !this.theme ? 'testClass' : 'selectMenu'
  }
  ngOnInit(): void {
    this.themingService.pingThemeName();
    let code = KeyWord.editorAuditCountry.find(e => {
      return e.country ==this.country
    })?.code
    let countryCode = code?.split(":")[1];
    this.defaultFlag = `https://flagpedia.net/data/flags/normal/${countryCode}.png`;
    // this.defaultFlag = `https://flagpedia.net/data/flags/normal/us.png`;
    this.languageType = this.language;
    this.selected = this.country;


    try {
      this.queryData.forEach((el:any,index:number) => {
        this.url = el;
        if(index>10){
         throw "break";
        }
        this.addContent('fromGsc');
      });
    } catch (error) {
      
    }
    this.url = "";

    // this.queryData.forEach((e: any) => {
    //   this.url = e;
    //   this.addContent('fromGsc');
    // })
    //   this.dropDownCountry.forEach((e:any)=>{
    //     e.flag="";
    // })
  }
  get bulkContent(): any {
    return this.bulkAuditForm.controls["bulkContent"].value as FormArray
  }
  checkEnter(event:any){
    let code = KeyWord.editorAuditCountry.find(e => {
      return e.country == event.target.innerText
    })?.code
    let countryCode = code?.split(":")[1];
    this.selectedFlag = `https://flagpedia.net/data/flags/normal/${countryCode}.png`;

  }
  newbulkContent(): FormGroup {
    return this.fb.group({
      keyword: [this.keyWordName,Validators.required],
      url: [this.url],
      location: [this.selected],
      language: [this.languageType],
      device: [this.crawlType],
    });
  }
  getFlags(value:any){
    let flagCode = KeyWord.editorAuditCountry.find(e => {
      return e.country ===value;
    })?.code;
    flagCode = flagCode?.split(':')[1];
    return  `https://flagpedia.net/data/flags/normal/${flagCode}.png`
  }
  clearMainForm() {
    this.keyWordName = "";
    this.url = "";
    this.selected = this.country;
    this.languageType = this.language;
    this.crawlType = "Desktop";
    let x : any = KeyWord.editorAuditCountry.find(v=>v.country == this.selected)
    this.countryValue = `${x.country}${x.code}`;
    let countryCode = x.code.split(':')[1];

    this.defaultFlag = `https://flagpedia.net/data/flags/normal/${countryCode}.png`;
    this.selectedFlag = "";
    this.key = "";
    this.languageKey = ""
    this.searchDropDownMainData('country')
    this.searchDropDownMainData('language')
  }
  addContent(arg?: string) {
    if (arg === 'fromGsc') {
      if (!this.isValidHttpUrl(this.url)) {
        this.toasterService.error("Url is Invalid");
      } else if (this.bulkAuditForm.controls['bulkContent'].value.length > 9) {
        this.toasterService.error("You can add upto 10 keywords");
      } else {
        if (!!this.isSelecting) {
          let countryIndex = this.dropDownCountry.findIndex((x: any) => x.country === this.selected)
          this.index[this.bulkAuditForm.controls['bulkContent'].value.length] = countryIndex;
          // this.dropDownCountry[this.mainFormCountryIndex].flag = this.selectedFlag;
          this.bulkContent.push(this.newbulkContent());
        } else {
          this.index[this.bulkAuditForm.controls['bulkContent'].value.length] = 0;
          // this.dropDownCountry[this.mainFormCountryIndex].flag = this.selectedFlag;
          this.bulkContent.push(this.newbulkContent());
        }
        this.isSelecting = false;
      }
    } else {
      if (this.keyWordName === '') {
        this.toasterService.error("Please add keyword.");
      } else if (!this.isValidHttpUrl(this.url)) {
        this.toasterService.error("Url is Invalid");
      } else if (this.bulkAuditForm.controls['bulkContent'].value.length > 9) {
        this.toasterService.error("You can add upto 10 keywords");
      } else {
        if (!!this.isSelecting) {
          let countryIndex = this.dropDownCountry.findIndex((x: any) => x.country === this.selected)
          this.index[this.bulkAuditForm.controls['bulkContent'].value.length] = countryIndex;
          // this.dropDownCountry[this.mainFormCountryIndex].flag = this.selectedFlag;
          this.bulkContent.push(this.newbulkContent());
        } else {
          this.index[this.bulkAuditForm.controls['bulkContent'].value.length] = 0;
          // this.dropDownCountry[this.mainFormCountryIndex].flag = this.selectedFlag;
          this.bulkContent.push(this.newbulkContent());
        }
        this.isSelecting = false;
      }
    }
  }
  removeContent(i: number) {
    this.bulkContent.removeAt(i);
    this.index.splice(i, 1)
  }
  getSelectedFlag(code: string, country: string, parentIndex: number, index: number) {
    this.index[parentIndex] = this.dropDownCountry.indexOf(this.dropDownCountry[index]);
    this.dropDownCountry[index].flag = `https://flagpedia.net/data/flags/normal/${code}.png`;
    this.countryValue = `${country}:${code}`;
  }

  onSubmit() {
    if (!!this.bulkAuditForm.valid) {
      let modifiedObj = this.bulkAuditForm.controls['bulkContent'].value?.value;
      modifiedObj = modifiedObj.map((e: any) => {
        // let countryName = e.location 
        // let locationName = KeyWord.editorAuditCountry.find(el => {
        //   return el.country === e.location
        // })?.code
        let x : any = KeyWord.editorAuditCountry.find(v=>v.country == e.location)
        delete e.location;
        return { location: `${x.country}${x.code}`, nlp: "nlp", ...e }
      });
      let checkFormArray = modifiedObj.some((el:any)=>el.keyword==='' || el.url==='');
      if(checkFormArray){
        this.toasterService.error("Please fill the blank fields")
      }else{
        this.activeModal.close(modifiedObj);
        this.bulkAuditForm.reset();
      }
    }

  }
  searchDropDownData(event: any, arg: string) {
    let key = event.target.value.toLowerCase();
    if (arg == 'country') {
      this.SearchedCountries = KeyWord.editorAuditCountry.filter(e => {
        return e.country.toLowerCase().search(key) >= 0
      })
    } else if (arg == 'language') {
      this.Searchedlanguages = KeyWord.editorAuditLanguages.filter(e => {
        return e.name.toLowerCase().search(key) >= 0
      })
    }
  }
  closeModal() {
    this.activeModal.close();
  }
  getSelectedMainFlag(code: string, country: string, index: number) {
    this.isSelecting = true;
    this.selectedFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
    this.mainDropDownCountry[index].flag = `https://flagpedia.net/data/flags/normal/${code}.png`;
    this.countryValue = `${country}:${code}`;
    this.mainFormCountryIndex = index;
    this.key = "";
    this.searchDropDownMainData('country');
  }
  searchDropDownMainData(arg: string) {
    if (arg == 'country') {
      this.mainDropDownCountry = KeyWord.editorAuditCountry.filter(e => {
        return e.country.toLowerCase().search(this.key.toLowerCase()) >= 0
      })
    } else if (arg == 'language') {
      this.mainLanguageDropdown = KeyWord.editorAuditLanguages.filter(e => {
        return e.name.toLowerCase().search(this.languageKey.toLowerCase()) >= 0
      })
    }
  }
  isValidHttpUrl(str: any) {
    const pattern = new RegExp(
      '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'
    );
    return pattern.test(str);
  }
}
